import React from 'react';
import Styled from './styles';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import api from '../../lib/api';
import { Fragment } from 'react';

const CustomSection = ({ data, smallSection }) => (
  <Styled.CustomSectionContainer key={data.id}>
    <Styled.CustomSectionVideo
      smallSection={smallSection}
      style={{
        backgroundImage: `url(${data.thumbnail})`,
        backgroundSize: 'cover'
      }}
      onClick={() => window.open(data.url, '_blank')}
    ></Styled.CustomSectionVideo>
    <Styled.CustomSectionSubtitle smallSection={smallSection}>
      {data.title}
    </Styled.CustomSectionSubtitle>
  </Styled.CustomSectionContainer>
);

const CustomSectionList = ({ title, data, smallSection }) => {
  return (
    <Fragment>
      <Styled.CustomSectionTitle>{title}</Styled.CustomSectionTitle>
      <Styled.DemoList>
        {data.map(element => (
          <CustomSection
            data={element}
            key={element.id}
            subTitle={element.title}
            smallSection={smallSection}
          />
        ))}
      </Styled.DemoList>
    </Fragment>
  );
};

class salesJetpack extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      companyId: window.location.search.replace('?companyId=', ''),
      data: {},
      loading: true,
      errorFetchingCompanyPitch: false
    };
  }

  async componentDidMount() {
    try {
      const result = await api.getCompanyPitchFromRemote(this.state.companyId);
      if (Object.keys(result).length === 0) {
        this.setState({ errorFetchingCompanyPitch: true });
      }
      this.setState({
        loading: false,
        data: result
      });
    } catch (error) {
      this.setState({
        loading: false,
        errorFetchingCompanyPitch: true
      });
    }
  }

  onVideoLinkClick = () => {
    // const tag = document.createElement('script');
    // tag.src = 'https://www.youtube.com/iframe_api';
    // const firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  render() {
    const { data, loading, errorFetchingCompanyPitch } = this.state;
    const {
      companyName = '',
      keyFeaturesToPitch = [],
      notImportantFeatures = [],
      references = [],
      productTypeValue = '',
      salesTraining = [],
      liveSalesCalls = [],
      liveDemos = [],
      testimonials = [],
      catalogues = []
    } = data || {};
    if (loading) {
      return (
        <Styled.SalesJetpackContainer>
          <Styled.SalesJetpackHeader>Sales Jetpack</Styled.SalesJetpackHeader>
          <Styled.LoaderContainer>
            <CircularProgress size={20} thickness={5} color="primary" />
          </Styled.LoaderContainer>
        </Styled.SalesJetpackContainer>
      );
    }

    if (errorFetchingCompanyPitch) {
      return (
        <Styled.SalesJetpackContainer>
          <Styled.SalesJetpackHeader>Sales Jetpack</Styled.SalesJetpackHeader>
          <Styled.LoaderContainer>
            Error finding data for given company ID.
          </Styled.LoaderContainer>
        </Styled.SalesJetpackContainer>
      );
    }
    return (
      <Styled.SalesJetpackContainer>
        <Styled.SalesJetpackHeader>
          <p>Sales Jetpack &#128640;</p>
        </Styled.SalesJetpackHeader>
        <Styled.SalesJetpackInfoContainer>
          <Styled.SalesPitchCompanyData>
            <Styled.SalesPitchFor>Sales Pitch For</Styled.SalesPitchFor>
            <Styled.CompanyInfo>
              <Styled.CompanyName>{companyName}</Styled.CompanyName>
              <Styled.SeparatorText>who is into</Styled.SeparatorText>
              <Styled.CompanyTags>{productTypeValue}</Styled.CompanyTags>
            </Styled.CompanyInfo>
            {data.template && (
              <Styled.TemplateData
                dangerouslySetInnerHTML={{ __html: data.template }}
              />
            )}
          </Styled.SalesPitchCompanyData>
          <Styled.SalesPitchTrainingData>
            {Array.isArray(salesTraining) && salesTraining.length > 0 && (
              <CustomSectionList
                title={'Sales Training'}
                data={salesTraining}
                smallSection={false}
              />
            )}
            {Array.isArray(keyFeaturesToPitch) && keyFeaturesToPitch.length && (
              <Styled.ExtraDataSection>
                <Styled.ExtraDataTitle green>
                  {'Key features to pitch'}
                </Styled.ExtraDataTitle>
                <Styled.ExtraDataContent>
                  {keyFeaturesToPitch.join(', ')}
                </Styled.ExtraDataContent>
              </Styled.ExtraDataSection>
            )}
            {Array.isArray(notImportantFeatures) &&
              notImportantFeatures.length && (
                <Styled.ExtraDataSection>
                  <Styled.ExtraDataTitle>
                    {'Not important features'}
                  </Styled.ExtraDataTitle>
                  <Styled.ExtraDataContent>
                    {notImportantFeatures.join(', ')}
                  </Styled.ExtraDataContent>
                </Styled.ExtraDataSection>
              )}
            {Array.isArray(references) && references.length && (
              <Styled.ExtraDataSection>
                <Styled.ExtraDataTitle>{'References'}</Styled.ExtraDataTitle>
                <Styled.ExtraDataContent>
                  {references.join(', ')}
                </Styled.ExtraDataContent>
              </Styled.ExtraDataSection>
            )}
            {Array.isArray(liveSalesCalls) && liveSalesCalls.length > 0 && (
              <CustomSectionList
                title={'Live sales calls'}
                data={liveSalesCalls}
                smallSection={true}
              />
            )}
            {Array.isArray(liveDemos) && liveDemos.length > 0 && (
              <CustomSectionList
                title={'Live Demo'}
                data={liveDemos}
                smallSection={true}
              />
            )}
            {Array.isArray(testimonials) && testimonials.length > 0 && (
              <CustomSectionList
                title={'Testimonials'}
                data={testimonials}
                smallSection={true}
              />
            )}
            {Array.isArray(catalogues) && catalogues.length > 0 && (
              <CustomSectionList
                title={'Catalogues'}
                data={catalogues}
                smallSection={true}
              />
            )}
          </Styled.SalesPitchTrainingData>
        </Styled.SalesJetpackInfoContainer>
      </Styled.SalesJetpackContainer>
    );
  }
}

export default withRouter(salesJetpack);



// WEBPACK FOOTER //
// ./src/pages/SalesJetpack/index.js